<!--<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h1 class="titulo-pagina">Administrador de Garantías</h1>
  </div>
</div>-->

<div class="grid">
  <div class="col-12 div-encabezado">
    <div class="items">
      <ng-container *ngFor="let tab of tabs">
        <div *ngIf="!tab.hidden"
             class="item"
             [ngClass]="{
               'item-seleccionado':  tabActiva === tab.key,
               'item-disponible':    tabActiva !== tab.key && !tab.disabled,
               'item-sinmovimiento': tab.disabled
             }"
             (click)="!tab.disabled && tabActiva !== tab.key ? seleccionar( tab.key ) : $event.preventDefault()">
          {{ tab.label }}
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div class="grid" *ngIf="!cargando">
  <div class="col-12 div-cuerpo">

    <!-- Listado de garantías -->
    <div [hidden]="tabActiva !== tabEnum.LISTADO">
      <app-admgar-listado
        *ngIf="seccionListado.editable && (tabActiva === tabEnum.LISTADO || tabsVisitadas.has( tabEnum.LISTADO ))"
        [seccionListado]="seccionListado">
      </app-admgar-listado>
    </div>

    <!-- Garantía idónea -->
    <div [hidden]="tabActiva !== tabEnum.GARANTIA_IDONEA">
      <app-admgar-garantia-idonea
        *ngIf="tabActiva === tabEnum.GARANTIA_IDONEA || tabsVisitadas.has( tabEnum.GARANTIA_IDONEA )"
        [seccionListado]="seccionGarantiaIdonea">
      </app-admgar-garantia-idonea>
    </div>

  </div>
</div>
